import React, { useContext, useEffect, useState } from "react";
import classnames from "classnames";
import "./range.scss";
import Responsive from "./responsive";
import ResetState from "./resetstate";
import { GrigoraEditorContext } from "../editor/context";

function RangeInput({
  value,
  onChange,
  className,
  step = 1,
  min = 0,
  max = 100,
  unit = "px",
  label = "",
  resetValue = 0,
  isResponsive = false,
  valueTablet,
  setValueTablet,
  resetValueTablet,
  valueMobile,
  setValueMobile,
  resetValueMobile,
}) {
  const [active, setActive] = useState("desktop");

  const editorContext = useContext(GrigoraEditorContext);

  useEffect(() => {
    if (editorContext?.displaySize && isResponsive) {
      setActive(editorContext.displaySize);
    }
  }, [editorContext?.displaySize]);

  value = Number(value);
  valueMobile = Number(valueMobile);
  valueTablet = Number(valueTablet);
  if (isNaN(value)) {
    value = resetValue;
  }
  if (isNaN(valueTablet)) {
    valueTablet = resetValueTablet;
  }
  if (isNaN(valueMobile)) {
    valueMobile = resetValueMobile;
  }
  if (value === undefined || value === null) {
    value = "";
  }
  if (valueTablet === undefined || valueTablet === null) {
    valueTablet = "";
  }
  if (valueMobile === undefined || valueMobile === null) {
    valueMobile = "";
  }
  const handleRangeValueChange = (e) => {
    if (active === "desktop") {
      onChange(e.target.value);
    } else if (active === "tablet") {
      setValueTablet(e.target.value);
    } else setValueMobile(e.target.value);
  };

  const classes = classnames(
    "grigora-range-input  text-grigora-base relative select-none w-full flex gap-4 items-center",
    className,
  );

  return (
    <div className={classes}>
      {label && (
        <div className="grigora-range-input__label flex flex-1 items-center ">
          {label}
          {/* {isResponsive && (
            <div className="relative">
              <Responsive
                activeMode={active}
                onChangeActiveMode={(e) => setActive(e)}
              />
            </div>
          )} */}
        </div>
      )}

      <ResetState
        active={
          (value !== resetValue && value != "") ||
          (valueTablet !== resetValueTablet && valueTablet != "") ||
          (valueMobile !== resetValueMobile && valueMobile != "")
        }
        onClick={() => {
          onChange(resetValue);
          if (isResponsive) {
            setActive("desktop");
            setValueTablet(resetValueTablet);
            setValueMobile(resetValueMobile);
          }
        }}
      />

      <input
        type="range"
        min={min}
        max={max}
        onChange={handleRangeValueChange}
        value={
          active === "desktop"
            ? value
            : active === "tablet"
            ? valueTablet
            : valueMobile
        }
        step={step}
        className="w-full focus-visible:outline-none flex flex-1"
      />
    </div>
  );
}

export default RangeInput;
